export const ASK_STANLEY_CONSTANTS = {
    CHAT_WIDTH: 400,
    CHAT_HEIGHT: '100%',
    FLOATING_BUTTON_SIZE: 56,
    FLOATING_BUTTON_POSITION: {
        bottom: 24,
        right: 24,
    },
    ANIMATION_DURATION: 150,
    MAX_ATTACHMENTS: 10,
    MAX_FILE_SIZE: 10 * 1024 * 1024, // 10MB
    ACCEPTED_FILE_TYPES: 'image/jpeg,image/png,image/jpg,.pdf,.md,.txt',
    STATUS_MESSAGES: {
        THINKING: 'Thinking...',
        TYPING: 'Typing...',
        GENERATING: 'Generating response...',
    },
    CHAT_MESSAGE_TYPES: {
        SENT: 'sent' as const,
        RECEIVED: 'received' as const,
        STATUS: 'status' as const,
    },
    MESSAGE_IDS: {
        CURRENT_STATUS: 'current-status',
    },
    CONTENT_TYPES: {
        TEXT: 'text' as const,
        PRODUCT: 'product' as const,
        INSTAGRAM_MAIN_FEED_POST: 'instagram-main-feed-post' as const,
    },
    DEFAULT_CHAT_TITLE: 'Store Setup Help',
    NEW_CHAT_TITLE: 'New Chat',
} as const;
